import { ComponentRenderHooks } from "@/plugins/types";
import OrderSummary from "./component";
import settings from "./settings";
import { ComponentTypes } from "@/Apps/Pages/Editor/types";
// import Properties from "./Properties";
import { Properties } from "./Properties/Properties";

export const onListItems = (hook, payload, actions) => {
  if (hook.id === ComponentRenderHooks.WEBCOMPONENT) {
    return [settings];
  }
};

export const onComponentRender = (hook, payload, actions) => {
  if (
    hook.id === ComponentRenderHooks.WEBCOMPONENT &&
    payload.type === ComponentTypes.ORDERSUMMARY
  ) {
    return [OrderSummary];
  }

  if (
    hook.id === ComponentRenderHooks.PROPERTIES &&
    hook.type === ComponentTypes.ORDERSUMMARY
  ) {
    return Properties(payload);
  }
};
